// API configuration for admin app
// In development, use proxy (/api) to avoid CORS issues
// In production, use the full backend URL from environment variable

// Get the backend base URL (without /api) for static files like uploads
export const getBackendBaseUrl = () => {
  if (process.env.REACT_APP_API_URL) {
    const url = process.env.REACT_APP_API_URL;
    // Remove trailing slash and /api suffix if present
    let cleanUrl = url.endsWith('/') ? url.slice(0, -1) : url;
    cleanUrl = cleanUrl.endsWith('/api') ? cleanUrl.slice(0, -4) : cleanUrl;
    return cleanUrl;
  }
  // In development with proxy, use empty string (relative URLs work)
  return '';
};

const getApiBaseUrl = () => {
  // If environment variable is set, use it
  // IMPORTANT: REACT_APP_API_URL should NOT include /api suffix
  // It should be just: https://revstar-main-platform-production.up.railway.app
  if (process.env.REACT_APP_API_URL) {
    const url = process.env.REACT_APP_API_URL;
    // Remove trailing slash if present
    const cleanUrl = url.endsWith('/') ? url.slice(0, -1) : url;
    // Only add /api if it's not already there
    return cleanUrl.endsWith('/api') ? cleanUrl : `${cleanUrl}/api`;
  }

  // In production (Vercel) or development, use proxy/rewrite
  // The Vercel rewrite rule in vercel.json will forward /api/* to Railway backend
  // This makes requests appear same-origin, allowing cookies to work
  return '/api';
};

const API_BASE_URL = getApiBaseUrl();

// Debug logging (always log in production for troubleshooting)
console.log('[Admin App] API_BASE_URL:', API_BASE_URL);
console.log('[Admin App] Environment:', process.env.NODE_ENV);
console.log('[Admin App] REACT_APP_API_URL:', process.env.REACT_APP_API_URL);

export const apiCall = async (endpoint, options = {}) => {
  const url = endpoint.startsWith('http')
    ? endpoint
    : `${API_BASE_URL}${endpoint}`;

  const defaultOptions = {
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  };

  const response = await fetch(url, { ...defaultOptions, ...options });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    const errorMessage =
      errorData.error ||
      errorData.message ||
      `${response.status} ${response.statusText}`;
    throw new Error(errorMessage);
  }

  return response.json();
};

export const api = {
  get: (endpoint) => apiCall(endpoint, { method: 'GET' }),
  post: (endpoint, data) =>
    apiCall(endpoint, { method: 'POST', body: JSON.stringify(data) }),
  put: (endpoint, data) =>
    apiCall(endpoint, { method: 'PUT', body: JSON.stringify(data) }),
  patch: (endpoint, data) =>
    apiCall(endpoint, { method: 'PATCH', body: JSON.stringify(data) }),
  delete: (endpoint) => apiCall(endpoint, { method: 'DELETE' }),
};

export default api;
